"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJwtExpireDate = exports.decodeJwtPayload = void 0;

/**
 * 解 JWT 的 payload
 *
 * 只解內容不驗簽章，僅供前端判斷 token 生命週期用，實際有效性仍以後端驗證為準。
 * @param {string} jwt
 * @returns {object|null} 格式不對時回傳 null
 */
var decodeJwtPayload = function decodeJwtPayload(jwt) {
  if (typeof jwt !== "string") return null;
  var payload = jwt.split(".")[1];
  if (!payload) return null;

  try {
    var base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    var padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    var json = decodeURIComponent(window.atob(padded).split("").map(function (char) {
      return "%".concat("00".concat(char.charCodeAt(0).toString(16)).slice(-2));
    }).join(""));
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};
/**
 * 取 JWT 的到期時間
 * @param {string} jwt
 * @returns {Date|null} 沒有 exp 或格式不對時回傳 null
 */


exports.decodeJwtPayload = decodeJwtPayload;

var getJwtExpireDate = function getJwtExpireDate(jwt) {
  var _ref = decodeJwtPayload(jwt) || {},
      exp = _ref.exp;

  if (typeof exp !== "number" || !Number.isFinite(exp)) return null;
  return new Date(exp * 1000);
};

exports.getJwtExpireDate = getJwtExpireDate;